import { render, staticRenderFns } from "./IconFlagVerified.vue?vue&type=template&id=6d7e2b66&"
import script from "./IconFlagVerified.vue?vue&type=script&lang=js&"
export * from "./IconFlagVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports